const relationshipStatuses = [
  { code: 'S', name: 'Single' },
  { code: 'M', name: 'Married' },
  { code: 'W', name: 'Widowed' },
  { code: 'D', name: 'Divorced' }
];

export default relationshipStatuses;
